import { makeRequest } from "./api";

export const FetchProperties = async (page, limit) => {
  return makeRequest(
    `/api/admin/manage/listings/fetch?page=${page}&limit=${limit}`,
  );
};

export const FetchInProgressProperties = async (page, limit, keyword) => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });
  if (keyword) params.set("key", keyword);
  return makeRequest(
    `/api/admin/manage/listings/in-progress?${params.toString()}`,
  );
};

export const SearchProperties = async (keyword, page, limit) => {
  return makeRequest(
    `/api/admin/manage/listings/search?key=${keyword}&page=${page}&limit=${limit}`,
  );
};

export const FetchSingleProperty = async (propertyId) => {
  return makeRequest(`/api/admin/manage/listings/single/${propertyId}`);
};

export const UpdateProperty = async ({ propertyId, status }) => {
  return makeRequest("/api/admin/manage/listings/update", {
    method: "PUT",
    data: { propertyId, status },
  });
};
export const DownloadCSV = async () => {
  return makeRequest("/api/admin/manage/listings/download-csv");
};

export const BulkCreateListings = async (listings, photosByRow = {}) => {
  const formData = new FormData();
  formData.append("listings", JSON.stringify(listings));

  Object.entries(photosByRow).forEach(([rowNumber, files]) => {
    (files || []).forEach((file) => {
      formData.append(`photos_${rowNumber}`, file);
    });
  });

  return makeRequest("/api/admin/manage/listings/bulk-create", {
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const FetchBulkCreateOptions = async () => {
  return makeRequest("/api/admin/manage/listings/bulk-create/options");
};

export const ValidateBulkCreateListings = async (listings) => {
  return makeRequest("/api/admin/manage/listings/bulk-create/validate", {
    method: "POST",
    data: { listings },
  });
};

export const FetchListingsRequests = async (page, limit, type = "listing") => {
  return makeRequest(
    `/api/admin/listing/requests/fetch?page=${page}&limit=${limit}&type=${type}`,
  );
};

export const ListingStatusUpdate = async (propertyId, status, reason) => {
  return makeRequest("/api/admin/listing/requests/update", {
    method: "PUT",
    data: { propertyId, status, reason },
  });
};

export const PermanentlyDeleteProperty = async (propertyId) => {
  return makeRequest(
    `/api/admin/listing/requests/permanently-delete/${propertyId}`,
    {
      method: "DELETE",
    },
  );
};
